export const selectDealId = (state) => {
  return state.startPage.application?.ids?.loan || null;
};

export const selectCreditId = (state) => {
  return state.startPage?.application?.ids?.credit || null;
};

export const selectDealState = (state) => {
  return state.deal?.id ? state.deal?.state : null;
};
